import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import '/public/css/pages/story.css';
import fetcher from '../../utils/fetcher';
import query from '../../endpoints/Department/department.gql';
import Sidebar from '../../components/Sidebar/Sidebar';
import adCleanup from '../../utils/adCleanup';
import { parseEmbeddedAssets } from '../../utils/utils';
import StaffTemplate from 'endpoints/Staff/staffTemplate';

const DepartmentPage = ({ data, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;
  let pageTopic = 'Department';
  return (
    <>
      <div id="mainContent"></div>
      <h1 className="hdg-section">MPR Newsroom</h1>

      <div className="container grid grid-4col grid-3-1">
        <div className="grid-primary">
          <StaffTemplate data={data} />
        </div>
        <div>
          <Sidebar pageTopic={pageTopic} />
        </div>
      </div>
    </>
  );
};

DepartmentPage.getInitialProps = async ({ query: { slug }, res }) => {
  let errorCode = false,
    result;

  if (res) {
    res.setHeader('Cache-Control', 'public, max-age=60');
  }

  try {
    result = await fetcher(query, {
      contentAreaSlug: process.env.CONTENT_AREA_SLUG,
      slug: slug.join('/'),
    });
    if (result?.department?.embeddedAssets) {
      parseEmbeddedAssets(result.department.embeddedAssets);
    }
  } catch (err) {
    if (res) res.statusCode = 500;
    return {
      data: {},
      errorCode: 500,
    };
  }

  if (!result?.department) {
    if (res) res.statusCode = 404;
    errorCode = 404;
  }

  adCleanup();
  return {
    data: result || {},
    errorCode,
  };
};

DepartmentPage.propTypes = {
  data: PropTypes.object,
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default DepartmentPage;
